// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-select-dropdown.is-multiple .el-select-dropdown__item.selected:after{content:\"\"!important}.el-select-dropdown.is-multiple .el-scrollbar{min-width:180px;max-width:300px}.el-select-dropdown__empty{min-width:110px;max-width:300px}", ""]);
// Exports
module.exports = exports;
